import { CURRENCY_SYMBOL } from "../Config";
export const WORKSPACE_USER_STATUS = {
  IN_PROGRESS: 0,
  ACTIVATED: 1,
  SUSPENDED: 2,
  EXPIRED: 3,
  PAYMENT_RECEIVED: 4,
  STUCK_WHILE_SETTING_AUTHENTICATION: 5,
  STUCK_DURING_OFFER_SELECTION: 6,
  STUCK_DUE_TO_CLOUD_IDENTITY_ALREADY_EXISTS: 7,
  STUCK_DURING_CUSTOMER_CREATION: 8,
  STUCK_DURING_CLOUD_IDENTITY_CREATION: 9,
  STUCK_DURING_PASSWORD_UPDATION: 10,
  STUCK_DURING_ENTITLEMENT_CREATION: 11,
  STUCK_WHILE_FETCHING_VERIFICATION_TOKEN: 12,
  STUCK_WHILE_FETCHING_DOMAIN_VERIFICATION_STATUS: 13,
  STUCK_DURING_NEW_USER_CREATION: 14,
  STUCK_DURING_ENTITLEMENT_UPDATION: 15,
  DELETED: 16,
  REFUNDED: 17,
  STATUS_LICENSE_SCHEDULED_FOR_DELETION: 18,
} as const;

export const WORKSPACE_BUY_BANNER = (workspacePriceDetails: any, minute: number, second: number) => {
  return {
    text: ` <div class="md-text14 white  center  fw4 ds-pl250">
  Get Professional Email ID at <span class="strike">₹1500</span>
  <span class="md-text16 white center  ds-ml8">
    <span class="fw6">
      ${CURRENCY_SYMBOL}
      ${workspacePriceDetails[0]?.per_year_per_license_price}
      /year
    </span>
  </span>
</div>`,
    btnText: "Get it now",
    subText: `<span class="md-text14 white fw4">
  Special Offer ends in
  <span class="fw5">
    ${minute}:${second}
  </span>
</span>`,
  };
};

/*
  following object shows all data about different
  plan types and their constant values setup
  in the BE. For more information about this
  contact Deepanshu Gaba
*/
export const WORKSPACE_PLAN_TYPE = {
  WORKSPACE_PLAN_ANNUAL_COMMITMENT: 1,
  WORKSPACE_PLAN_HALF_YEAR_FLEXI: 2,
  WORKSPACE_PLAN_QUARTER_FLEXI: 3,
  WORKSPACE_PLAN_ANNUAL_FLEXI: 4,
  WORKSPACE_PLAN_DOMAIN_UPSELL: 5,
} as const;

/*
  following object contains data about
  the overall workspace status values
*/
export const WORKSPACE_INFO_STATUS = {
  WORKSPACE_STATUS_PAYMENT_RECEIVED: 0,
  WORKSPACE_STATUS_IN_PROGRESS: 1,
  WORKSPACE_STATUS_ACTIVE: 2,
  WORKSPACE_STATUS_EXPIRED: 3,
  WORKSPACE_STATUS_DELETED: 4,
  WORKSPACE_STATUS_PAYMENT_REFUNDED: 5,
  WORKSPACE_STATUS_DUE_FOR_RENEWAL: 6,
  WORKSPACE_RENEWAL_ON_DATE: 7,
  WORKSPACE_SUSPENDED_DUE_TO_DOMAIN_EXPIRY: 8,
  WORKSPACE_ACC_CANCELLED_DUE_TO_TOS_NOT_ACCEPTED: 9,
  ACCOUNT_DUE_TO_LICENSE_CAP_REDUCTION_AFTER_RENEWAL: 10,
  WORKSPACE_STATUS_STUCK_TITAN_ORDER: 14,
  WORKSPACE_STATUS_READY_FOR_ACTIVATION: 16,
} as const;

export const WORKSPACE_PURCHASE_SOURCE = {
  GOOGLE: "google",
  TITAN: "titan",
} as const;
